import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import UIModal from 'UIComponents/dialog/UIModal';
import SuiteFeatureTable from '../feature-table/SuiteFeatureTable';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { AllProductLines } from 'self-service-api/constants/ProductLines';
import { ProductLinePageIcons } from 'ui-addon-upgrades/_core/productPage/ProductPageIcons';
import { ProductLineIcon, IconImage } from '../splash-page/SplashPageSharedComponents';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIList from 'UIComponents/list/UIList';
import styled from 'styled-components';
import UIGrid from 'UIComponents/grid/UIGrid';
import UIGridItem from 'UIComponents/grid/UIGridItem';
import { H4 } from 'UIComponents/elements/headings';
import { STARTER_SUITE_MODAL_CBX003 } from '../../constants/tracking/Locations';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
const Bold = styled.span.withConfig({
  displayName: "LearnMoreModal__Bold",
  componentId: "fpeaev-0"
})(["font-weight:bold;"]);
export const LearnMoreModal = ({
  screen,
  setIsLearnMoreModalOpen,
  productsByProductLine
}) => {
  useEffect(() => {
    getUsageTracker().track('modalInteraction', {
      action: 'viewed',
      modalName: 'starter-crm-suite-learn-more-modal'
    });
  }, []);

  const IncludesHubsSection = () => {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(UIGrid, {
        children: AllProductLines.map(key => {
          return /*#__PURE__*/_jsxs(UIGridItem, {
            size: 6,
            className: "flex-column",
            children: [/*#__PURE__*/_jsxs(ProductLineIcon, {
              className: "flex-row m-y-1 m-left-0",
              children: [/*#__PURE__*/_jsx(IconImage, {
                className: "m-right-3 m-top-1",
                src: ProductLinePageIcons[key],
                style: {
                  height: '18px'
                }
              }), /*#__PURE__*/_jsx(Bold, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: `CBX003.starterSuiteGWPCard.includes.${key}`
                })
              })]
            }, key), /*#__PURE__*/_jsx("div", {
              className: "m-left-8",
              style: {
                height: '100%'
              },
              children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
                message: `CBX003.learnMoreModal.${key}.description_jsx`,
                elements: {
                  UIList
                }
              })
            })]
          }, key);
        })
      })
    });
  };

  const onCloseClick = () => {
    setIsLearnMoreModalOpen(false);
    getUsageTracker().track('modalInteraction', {
      modalName: 'starter-crm-suite-learn-more-modal',
      action: 'closed',
      screen
    });
  };

  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    style: {
      width: '100%'
    },
    size: "auto",
    width: 1200,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      children: /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onCloseClick
      })
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      className: "text-left",
      children: [/*#__PURE__*/_jsx(H4, {
        className: "justify-center m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CBX003.starterSuiteGWPCard.title"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "text-center",
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "CBX003.starterSuiteGWPCard.subtitle_jsx",
          elements: {
            b: 'b'
          },
          options: {
            hubName: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `pricingPage.products.${screen.toUpperCase()}.STARTER`
            })
          }
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "m-top-10 m-bottom-1",
        style: {
          fontSize: '1.125em',
          fontWeight: 600,
          alignContent: 'start'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `CBX003.starterSuiteGWPCard.includes.title`
        })
      }), /*#__PURE__*/_jsx(IncludesHubsSection, {}), productsByProductLine && /*#__PURE__*/_jsx(SuiteFeatureTable, {
        productsByProductLine: productsByProductLine,
        screen: screen,
        titleKey: `CBX003.learnMoreModal.featureTable.title`,
        trackingSource: STARTER_SUITE_MODAL_CBX003,
        isLearnMoreModal: true
      })]
    })]
  });
};